var map;

$(document).ready(function() {
    if(_site.module == "home") {
        checkBgFade();
        if($(window).width() > mobile) {
            checkLeftScroll();
            createMap();
        }
        attachWelcome();
    }
});
function checkLeftScroll() {
    $('.lt_content').height('auto');
    var wh = $(window).height();
    var sfh = $('#site_footer').height() + 60;
    var lth = $('.lefttoolbar').height();

    if( lth > (wh - sfh) ) {
        $('.lt_content').height( (wh - sfh) - 140);

    }
}
function checkBgFade() {
    var gotit = localStorage.getItem('seenGotIt');
    if(gotit == null) {
        $('.welcome_lb, .lb_bg').fadeIn();
    }
}

function attachWelcome() {
    $('.btn.gotit').on('click', function() {
        $('.lb_bg').fadeOut();
        $('.welcome_lb').fadeOut();
        localStorage.setItem('seenGotIt', true);
    });
}
function createMap() {
    map = L.map('map', {
        center: [57.994088, -126.849976],
        zoom: 4
    });

    map.zoomControl.setPosition('topright');

    var southWest = L.latLng(57.994088, -150.849976),
    northEast = L.latLng(-50.941113, 125.974045),
    bounds = L.latLngBounds(southWest, northEast);

    L.tileLayer('img/tiles/{z}/{x}/{y}.png', {
        maxBounds: bounds,
        minZoom: 2,
        maxZoom: 5,
        noWrap: true
    }).addTo(map);

    map.setMaxBounds(bounds);
    map.on('drag', function() {
        map.panInsideBounds(bounds, { animate: false });
    });

    map.on('zoomend', function() {
        var currentZoom = map.getZoom();
        if(currentZoom == 2) {
            smallerIcons();
        } else {
            largerIcons();
        }
    });

    // Icons
    var marker_ss_icon = L.icon({
        iconUrl: 'img/map/signs-and-symptoms.png',
        iconAnchor: [40,73],
        iconSize: [248,83] 
    })
    var marker_ss = L.marker([48.579101, -71.969719], {
        icon: marker_ss_icon
    }).addTo(map);
    marker_ss.on('click', function() {
        location.href = "signs-and-symptoms";
    });

    var marker_diag_icon = L.icon({
        iconUrl: 'img/map/diagnosis.png',
        iconAnchor: [40,73],
        iconSize: [162,83] 
    })
    var marker_diag = L.marker([40.233014, -20.312004], {
        icon: marker_diag_icon
    }).addTo(map);
    marker_diag.on('click', function() {
        location.href = "diagnosis";
    });

    var marker_trtmt_icon = L.icon({
        iconUrl: 'img/map/treatment.png',
        iconAnchor: [40,73],
        iconSize: [172,83] 
    })
    var marker_trtmt = L.marker([36.163121, 5.727997], {
        icon: marker_trtmt_icon
    }).addTo(map);
    marker_trtmt.on('click', function() {
        location.href = "treatment";
    });

    var marker_lwf_icon = L.icon({
            iconUrl: 'img/map/living-with-fabry.png',
            iconAnchor: [40,73],
            iconSize: [191,83] 
    })
    var marker_lwf = L.marker([33.178793, 35.102005], {
        icon: marker_lwf_icon
    }).addTo(map);
    marker_lwf.on('click', function() {
        location.href = "living-with-fabry";
    });

    var marker_sprt_icon = L.icon({
            iconUrl: 'img/map/support.png',
            iconAnchor: [40,73],
            iconSize: [148,75] 
    })
    var marker_sprt = L.marker([19.200341, 73.860397], {
        icon: marker_sprt_icon
    }).addTo(map);
    marker_sprt.on('click', function() {
        location.href = "support";
    });

    var marker_news_icon = L.icon({
            iconUrl: 'img/map/news.png',
            iconAnchor: [40,73],
            iconSize: [131,83] 
    })
    var marker_news = L.marker([-11.344811, 84.756775], {
        icon: marker_news_icon
    }).addTo(map);
    marker_news.on('click', function() {
        location.href = "news";
    });

    var marker_fmtree_icon = L.icon({
            iconUrl: 'img/map/family-tree.png',
            iconAnchor: [40,73],
            iconSize: [178,83] 
    })
    var marker_fmtree = L.marker([-1.621671, -8.291245], {
        icon: marker_fmtree_icon
    }).addTo(map);
    marker_fmtree.on('click', function() {
        location.href = "family-tree";
    });

    var marker_genetics_icon = L.icon({
        iconUrl: 'img/map/genetics.png',
        iconAnchor: [40,73],
        iconSize: [157,83] 
    })
    var marker_genetics = L.marker([14.169745, -41.452789], {
        icon: marker_genetics_icon
    }).addTo(map);
    marker_genetics.on('click', function() {
        location.href = "genetics";
    });
}

function smallerIcons() {
    $('.mod_home .leaflet-pane img.leaflet-marker-icon').addClass('smaller');
}
function largerIcons() {
    $('.mod_home .leaflet-pane img.leaflet-marker-icon').removeClass('smaller');
}